import { createAction } from '@reduxjs/toolkit';

const setSendMethod = createAction('user/setSendMethod');

export const persistedActions = {
	setSendMethod
};
